import { render } from "./StatisticKpi.vue?vue&type=template&id=40267658"
import script from "./StatisticKpi.vue?vue&type=script&lang=js"
export * from "./StatisticKpi.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__